var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4242_9842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.68 9.18183C16.68 8.61456 16.6291 8.06911 16.5345 7.54547H9V10.64H13.3055C13.12 11.64 12.5564 12.4873 11.7091 13.0546V15.0618H14.2945C15.8073 13.6691 16.68 11.6182 16.68 9.18183Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99968 17C11.1597 17 12.9706 16.2837 14.2942 15.0618L11.7088 13.0546C10.9924 13.5346 10.076 13.8182 8.99968 13.8182C6.91604 13.8182 5.1524 12.4109 4.52331 10.52H1.85059V12.5927C3.16695 15.2073 5.8724 17 8.99968 17Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52364 10.52C4.36364 10.04 4.27273 9.52729 4.27273 9.00001C4.27273 8.47274 4.36364 7.96001 4.52364 7.48001V5.40729H1.85091C1.30909 6.48729 1 7.70911 1 9.00001C1 10.2909 1.30909 11.5127 1.85091 12.5927L4.52364 10.52Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99968 4.18182C10.1742 4.18182 11.2288 4.58545 12.0579 5.37818L14.3524 3.08364C12.9669 1.79273 11.156 1 8.99968 1C5.8724 1 3.16695 2.79273 1.85059 5.40727L4.52331 7.48C5.1524 5.58909 6.91604 4.18182 8.99968 4.18182Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4242_9842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.4e7c2d58b7cc0ca840f5b663d44381a1.svg";
export { ForwardRef as ReactComponent };